import gameConsts from './gameConsts';
import consts from './consts';

export default class Control {
  constructor({ game, name, player }) {
    this._game = game;
    this._name = name;
    this._img = this._game.cache.getImage(this._name);
    this._height = this._img.height / 2;
    this._width = this._img.width / 2;
    this._item = this._game.add.button(this._coordX, this._coordY, this._name, null, this);
    this._player = player;
    this._item.inputEnabled = true;
    this._item.scale.setTo(0.5, 0.5);
    this.addEvents();
  }
  // eslint-disable-next-line
  get _padding() {
    return window.innerWidth <= consts.MAX_WINDOW_WIDTH_XS ? 30 : 56;
  }
  get _coordY() {
    return gameConsts.GAME_HEIGHT - (this._padding + this._height);
  }
  get _coordX() {
    const visibleWidth = window.innerWidth <= consts.MAX_WINDOW_WIDTH_XS ? window.innerWidth : gameConsts.GAME_WIDTH;
    return ((gameConsts.GAME_WIDTH - visibleWidth) / 2) +
      (this._name === 'left' ? this._padding : (visibleWidth - (this._width + this._padding)));
  }
  _addAction(clicked) {
    this._player.controls[this._name] = clicked;
  }
  update() {
    this._item.position.x = this._coordX;
    this._item.position.y = this._coordY;
  }
  delete() {
    if (this._item) {
      this._item.position.x = gameConsts.GAME_WIDTH;
    }
  }
  addEvents() {
    this._item.onInputDown.add(() => {
      this._addAction(true);
    });
    this._item.onInputUp.add(() => {
      this._addAction(false);
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/Control.js